import { useContext, useEffect, useState } from "react";
import TailwindLayout from "TailwindcssComponents/TailwindLayout";
import TopBar from "TailwindcssComponents/TopBar";
import FooterTailwind from "TailwindcssComponents/Footer";
import { Icon } from "@iconify/react";
import axios from "axios";
import { UserDataContext } from "context";
import { useNavigate } from "react-router-dom";

function Dashboard() {
  const apiUrl = process.env.REACT_APP_API_BASE_URL;
  const bearerToken = localStorage.getItem('token');
  const { userData, selectedOrganization } = useContext(UserDataContext);
  const userRole = userData?.isAdmin ? 'admin' : selectedOrganization?.name || 'user';
  const userName = `${userData?.firstName || ''} ${userData?.lastName || ''}`.trim();
  const [isLoading, setIsLoading] = useState(true);
  const [counts, setCounts] = useState({
    organizations: 0,
    venues: 0,
    events: 0,
    tickets: 0,
  });
  const navigate = useNavigate();

  const fetchAllCounts = async () => {
    try {
      setIsLoading(true);
      const [
        orgRes,
        venuesRes,
        eventsRes,
        ticketsRes
      ] = await Promise.all([
        axios.get(`${apiUrl}auth-service/org`, { headers: { Authorization: `Bearer ${bearerToken}` } }),
        axios.get(`${apiUrl}event-service/event-venue`),
        axios.get(`${apiUrl}event-service/event`),
        axios.get(`${apiUrl}event-service/event-ticket`),
      ]);

      setCounts({
        organizations: orgRes.data?.totalItems || 0,
        venues: venuesRes.data?.totalItems || 0,
        events: eventsRes.data?.totalItems || 0,
        tickets: ticketsRes.data?.totalItems || 0,
      });

    } catch (error) {
      console.error('Failed to fetch dashboard data:', error.response?.data?.message || error.message);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchAllCounts();
  }, [bearerToken]);

  return (
    <TailwindLayout>
      <TopBar />
      <div className="p-12 bg-gray-100 min-h-screen mb-8">
        {isLoading ? (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-4 animate-pulse">
            {Array(4).fill(0).map((_, index) => (
              <div key={index} className="bg-white rounded-lg shadow p-6 flex items-center space-x-4">
                <div className="rounded-full bg-gray-200 h-12 w-12"></div>
                <div className="flex-1 space-y-2 py-1">
                  <div className="h-4 bg-gray-200 rounded w-3/4"></div>
                  <div className="h-4 bg-gray-200 rounded w-1/2"></div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className='bg-white rounded-lg shadow-lg p-6'>
            <p className='pt-2 pb-4 text-xl font-semibold'>Hi! {userName}</p>
            {userRole === 'admin' && (
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-4">

                {/* Organizations Card */}
                <div
                  onClick={() => navigate('/eventOrganizations')}
                  className="bg-white rounded-lg shadow p-6 flex items-center cursor-pointer hover:shadow-lg transition"
                >
                  <div className="rounded-full bg-black/5 p-3 mr-4">
                    <Icon icon="simple-icons:awsorganizations" className="h-8 w-8 p-1" />
                  </div>
                  <div>
                    <div className="text-3xl font-bold">{counts.organizations}</div>
                    <div className="text-gray-500">Total Organizations</div>
                  </div>
                </div>

                {/* Venues Card */}
                <div
                  onClick={() => navigate('/venues')}
                  className="bg-white rounded-lg shadow p-6 flex items-center cursor-pointer hover:shadow-lg transition"
                >
                  <div className="rounded-full bg-black/5 p-3 mr-4">
                    <Icon icon="ph:buildings-light" className="h-8 w-8 p-1" />
                  </div>
                  <div>
                    <div className="text-3xl font-bold">{counts.venues}</div>
                    <div className="text-gray-500">Total Venues</div>
                  </div>
                </div>

                {/* Events Card */}
                <div
                  onClick={() => navigate('/events/view-events')}
                  className="bg-white rounded-lg shadow p-6 flex items-center cursor-pointer hover:shadow-lg transition"
                >
                  <div className="rounded-full bg-black/5 p-3 mr-4">
                    <Icon icon="carbon:event" className="h-8 w-8 p-1" />
                  </div>
                  <div>
                    <div className="text-3xl font-bold">{counts.events}</div>
                    <div className="text-gray-500">Total Events</div>
                  </div>
                </div>

                {/* Tickets Card */}
                <div
                  onClick={() => navigate('/view-eventTickets')}
                  className="bg-white rounded-lg shadow p-6 flex items-center cursor-pointer hover:shadow-lg transition"
                >
                  <div className="rounded-full bg-black/5 p-3 mr-4">
                    <Icon icon="streamline:tickets" className="h-8 w-8 p-1" />
                  </div>
                  <div>
                    <div className="text-3xl font-bold">{counts.tickets}</div>
                    <div className="text-gray-500">Total Tickets</div>
                  </div>
                </div>

              </div>
            )}
          </div>
        )}
      </div>
      <FooterTailwind />
    </TailwindLayout>
  );
}

export default Dashboard;
